<template>
    <div>
        <base-input
            v-model="form.name"
            validate="required"
            label="Name"
            name="name"/><br/>

        <base-button
            :loading="loading"
            @click="submit"
            class="is-primary"
            icon="fas fa-check"
            text="Save"/>&nbsp;

        <base-button
            :loading="loading"
            @click="$emit('cancel')"
            class="is-danger"
            icon="fas fa-times"
            text="Cancel"/>
    </div>
</template>

<script>
export default {
    name: 'FlowForm',
    props: {
        loading: { type: Boolean },
        init_data: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            form: { name: '', ...this.init_data },
        };
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$emit('submit', this.form);
            });
        },
    },
};
</script>
